import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductById } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getProductById(props.apiParameter);
    } catch (error) {
        return false;
    }
});
